import { defineMessages } from 'react-intl'

export default defineMessages({
  drawerTitle: {
    id: 'editExpenseLineItemDrawerPresenter.drawerTitle',
    defaultMessage: 'Edit expense line',
  },
  cancelButton: {
    id: 'editExpenseLineItemDrawer.cancelButton',
    defaultMessage: 'Cancel',
  },
  saveButton: {
    id: 'editExpenseLineItemDrawer.saveButton',
    defaultMessage: 'Save',
  },
  saveSuccessTitle: {
    id: 'editExpenseLineItemDrawer.saveSuccessTitle',
    defaultMessage: 'Item has been saved',
  },
  saveErrorTitle: {
    id: 'editExpenseLineItemDrawer.saveErrorTitle',
    defaultMessage: 'Failed to save item',
  },
})
